/* Collection page: sort, the filter drawer, and applying facets without
   a full page reload.

   Filtering uses the Section Rendering API — the same URL the shopper
   would land on is fetched, and only the grid and the facet panel are
   swapped in. With JavaScript off, the form still submits normally and
   Shopify renders the filtered page server-side, so nothing is lost. */
(function () {
  var form = document.getElementById('PbFacetForm');
  var sortForm = document.getElementById('PbSortForm');
  var panel = document.getElementById('PbFacets');
  var scrim = document.querySelector('[data-facets-scrim]');
  var openBtn = document.querySelector('[data-facets-open]');
  var closeBtn = document.querySelector('[data-facets-close]');

  // --- drawer ----------------------------------------------------------

  function openPanel() {
    if (!panel) return;
    panel.classList.add('is-open');
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (scrim) scrim.hidden = true;
    document.body.style.overflow = '';
    if (openBtn) openBtn.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openPanel);
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  if (scrim) scrim.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && panel && panel.classList.contains('is-open')) closePanel();
  });

  // --- sticky sidebar offset ---------------------------------------------
  // The sticky header's real height, not a guess: it changes with the
  // fluid type scale (perfumebox-base.css) and with whether the
  // announcement bar or sale banner are enabled, so a hardcoded top offset
  // would drift out of sync with the actual header at some breakpoint.
  // Re-measured on resize since the header's own layout (and therefore
  // height) changes at the same 990px breakpoint the sidebar itself does.

  function setStickyOffset() {
    // Only the header itself is sticky - the announcement bar and any sale
    // banner above it scroll away normally, confirmed by watching all
    // three on scroll rather than assumed from the markup. So the header's
    // own height, not the whole group's, is the real offset once a
    // shopper has scrolled past the announcement bar.
    var header = document.querySelector('.pb-header-section');
    if (!header) return;
    var height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--pb-sticky-offset', height + 8 + 'px');
  }

  setStickyOffset();

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(setStickyOffset, 150);
  });

  // --- facet list "show more" -------------------------------------------
  // Delegated on document, same reasoning as the price slider: the facet
  // panel's innerHTML is replaced wholesale on every AJAX filter update, so
  // a listener bound to a specific button would be gone after the next
  // change. The list beyond 10 items ships with those extra <li>s already
  // marked hidden from Liquid; this only ever removes that attribute, it
  // doesn't re-derive which items count as "extra".

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-facet-list-toggle]');
    if (!toggle) return;

    var list = toggle.previousElementSibling;
    if (!list || !list.classList.contains('pb-facet__list')) return;

    var expanded = list.classList.toggle('is-expanded');
    toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    Array.prototype.forEach.call(list.children, function (item, index) {
      if (index < 10) return;
      item.hidden = !expanded;
    });
  });

  // --- collapsible description ------------------------------------------
  // The toggle button starts hidden in the markup and only appears once the
  // clamp is confirmed to actually be cutting text off - scrollHeight
  // exceeding clientHeight means real content is hidden, not just that the
  // clamp CSS is present.

  document.querySelectorAll('[data-collection-desc]').forEach(function (wrap) {
    var body = wrap.querySelector('.pb-collection__desc');
    var toggle = wrap.querySelector('[data-desc-toggle]');
    if (!body || !toggle) return;

    if (body.scrollHeight > body.clientHeight + 1) {
      toggle.hidden = false;
    }

    toggle.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // --- sort ------------------------------------------------------------

  if (sortForm) {
    var select = sortForm.querySelector('select[name="sort_by"]');
    if (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        navigate(url.toString());
      });
    }
  }

  // --- facets ----------------------------------------------------------

  var sectionId = null;
  var grid = document.getElementById('PbProductGrid');

  function buildUrl() {
    var params = new URLSearchParams(new FormData(form));

    // FormData keeps empty price fields and unchecked boxes out already,
    // but an empty string would still produce "&filter.v.price.gte=".
    var cleaned = new URLSearchParams();
    params.forEach(function (value, key) {
      if (value !== '') cleaned.append(key, value);
    });

    var base = window.location.pathname;
    var query = cleaned.toString();
    return query ? base + '?' + query : base;
  }

  var inFlight = null;

  function navigate(url, push) {
    if (inFlight) inFlight.abort();
    inFlight = new AbortController();

    if (grid) grid.setAttribute('aria-busy', 'true');

    fetch(url, { signal: inFlight.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Swap the regions a filter change can affect. Anything outside
        // them — header, footer, app embeds — is left untouched.
        ['PbProductGrid', 'PbFacets', 'PbActiveFilters'].forEach(function (id) {
          var next = doc.getElementById(id);
          var current = document.getElementById(id);
          if (next && current) current.innerHTML = next.innerHTML;
        });

        var nextCount = doc.querySelector('.pb-collection__count');
        var count = document.querySelector('.pb-collection__count');
        if (nextCount && count) count.textContent = nextCount.textContent;

        var nextPager = doc.querySelector('.pb-pagination');
        var pager = document.querySelector('.pb-pagination');
        if (pager) {
          if (nextPager) pager.innerHTML = nextPager.innerHTML;
          else pager.remove();
        }

        if (push !== false) window.history.pushState({ pb: true }, '', url);
        grid = document.getElementById('PbProductGrid');
        if (grid) grid.removeAttribute('aria-busy');
        bindFacets();
      })
      .catch(function (error) {
        // An aborted request is the expected outcome when a shopper ticks
        // two boxes quickly; only a real failure should fall back.
        if (error.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  function bindFacets() {
    var current = document.getElementById('PbFacetForm');
    if (!current) return;
    form = current;

    form.addEventListener('change', function () {
      navigate(buildUrl());
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      navigate(buildUrl());
    });
  }

  if (form) bindFacets();

  // Remove-one-filter chips, the row's own "clear all", and the sidebar's
  // "clear all" all point at a real href for no-JS, but with JS available
  // they should feel like every other filter change - same fetch, same
  // loading state, same in-place swap, rather than a full reload that
  // would flash the whole page white and drop scroll position. Delegated
  // on document rather than bound directly: all three links live inside
  // #PbActiveFilters or #PbFacets, both replaced wholesale on every filter
  // change, so a direct binding would only survive one click.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.pb-active-filters__chip, .pb-active-filters__clear, .pb-facets__clear');
    if (!link) return;

    event.preventDefault();
    navigate(link.getAttribute('href'));
  });

  window.addEventListener('popstate', function () {
    navigate(window.location.href, false);
  });
})();
